// ============================================================
// 📌 Estados de cita + Métodos de pago – Módulo centralizado
// ============================================================

// ------------------------------------------------------------
// TIPOS
// ------------------------------------------------------------
export type EstadoCita =
  | 'pendiente'
  | 'confirmado'
  | 'cancelado'
  | 'completado'
  | 'anulado';

export interface InfoEstadoCita {
  estado: EstadoCita;
  color: string; // Clase Tailwind
  label: string;
  short: string;
}

// Métodos de pago soportados
export type MetodoPago = 'tarjeta' | 'efectivo' | 'bizum' | 'otros' | 'bono';

// Info extendida de pago
export interface InfoPago {
  metodo: MetodoPago;
  icono: string;
  label: string;
}

// ------------------------------------------------------------
// 📌 ESTADOS DE CITA
// ------------------------------------------------------------
export const ESTADOS_CITA: InfoEstadoCita[] = [
  {
    estado: 'confirmado',
    color: 'bg-blue-500',
    label: 'Confirmado',
    short: 'Con.',
  },
  {
    estado: 'cancelado',
    color: 'bg-red-500',
    label: 'Cancelado',
    short: 'Can.',
  },
  {
    estado: 'completado',
    color: 'bg-green-500',
    label: 'Completado',
    short: 'Comp.',
  },
  {
    estado: 'anulado',
    color: 'bg-yellow-500',
    label: 'Anulado',
    short: 'Anu.',
  },
];

// ------------------------------------------------------------
// 📌 MÉTODOS DE PAGO
// ------------------------------------------------------------
export const METODOS_PAGO: InfoPago[] = [
  { metodo: 'tarjeta', icono: '💳', label: 'Tarjeta' },
  { metodo: 'efectivo', icono: '💵', label: 'Efectivo' },
  { metodo: 'bizum', icono: '📲', label: 'Bizum' },
  { metodo: 'otros', icono: '💼', label: 'Otros' },
  { metodo: 'bono', icono: '🎟️', label: 'Bono' },
];

// ------------------------------------------------------------
// 📌 HELPERS
// ------------------------------------------------------------

// Devuelve el color del estado
export const getEstadoColor = (estado: string): string => {
  return ESTADOS_CITA.find((e) => e.estado === estado)?.color || 'bg-gray-400';
};

// Devuelve la info completa del estado
export const getEstadoInfo = (estado: string): InfoEstadoCita | undefined => {
  return ESTADOS_CITA.find((e) => e.estado === estado);
};

// Devuelve icono de pago
export const getIconoPago = (metodo: string): string | null => {
  return (
    METODOS_PAGO.find((m) => m.metodo.toLowerCase() === metodo?.toLowerCase())
      ?.icono || null
  );
};

// Devuelve la info completa del método de pago
export const getPagoInfo = (metodo: string): InfoPago | undefined => {
  return METODOS_PAGO.find(
    (m) => m.metodo.toLowerCase() === metodo?.toLowerCase()
  );
};
